// Client V2 common imports
const {
  ARTICLE_UPDATED
} = require('client-v2/common/models/article/actions')
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Container imports
const { loadCollections } = require('./slide-actions')
const { getCurrentModalSlide } = require('./selectors')

function articleProfileMiddleware() {
  return store => {
    return next => action => {
      if (action.type === ARTICLE_UPDATED) {
        const { urlId } = action.payload
        const state = store.getState()
        maybeUpdateSlide(state.articleProfile, urlId)
        maybeUpdateSlide(getCurrentModalSlide(state), urlId)
      }
      next(action)
    }
    function maybeUpdateSlide(slide, urlId) {
      if (slide && slide.article['url_id'] === urlId) {
        if (slide.collectionsState !== FetchStateEnum.LOADING) {
          store.dispatch(loadCollections({ article: slide.article }))
        }
      }
    }
  }
}

module.exports = articleProfileMiddleware
